export const JobTitleVI = {
    "jobTitle": {
        "title": {
            "header": "Danh sách chức vụ",
            "add": "Tạo mới chức vụ",
            "update": "Cập nhật chức vụ"
        },
       
    }
}